(function () {
  let overlayScrollY = 0;
  let tiktokEmbedPromise = null;

  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function lockScroll() {
    overlayScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.top = `-${overlayScrollY}px`;
    document.body.classList.add('nawa-video-overlay-open');
  }

  function unlockScroll() {
    if (!document.body.classList.contains('nawa-video-overlay-open')) return;
    document.body.classList.remove('nawa-video-overlay-open');
    document.body.style.top = '';
    window.scrollTo(0, overlayScrollY);
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.hidden = true;
    const video = qs('video', overlay);
    if (video) video.pause();
    qsa('iframe', overlay).forEach((iframe) => {
      if (!iframe.src) return;
      iframe.src = iframe.src;
    });
    if (!qs('[data-nawa-video-overlay]:not([hidden])')) unlockScroll();
  }

  function closeAllOverlays() {
    qsa('[data-nawa-video-overlay]').forEach(closeOverlay);
  }

  function loadTikTokEmbed() {
    if (window.tiktokEmbedLoaded || qs('script[src*="tiktok.com/embed.js"]')) {
      return Promise.resolve();
    }

    if (tiktokEmbedPromise) return tiktokEmbedPromise;

    tiktokEmbedPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      script.onload = () => {
        window.tiktokEmbedLoaded = true;
        resolve();
      };
      script.onerror = resolve;
      document.body.appendChild(script);
    });

    return tiktokEmbedPromise;
  }

  function openOverlay(id) {
    const overlay = document.getElementById(id);
    if (!overlay) return;
    closeAllOverlays();
    overlay.hidden = false;
    lockScroll();
    if (qs('.tiktok-embed', overlay)) {
      loadTikTokEmbed();
    }
    const video = qs('video', overlay);
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function important(node, styles) {
    Object.keys(styles).forEach((key) => {
      node.style.setProperty(key, styles[key], 'important');
    });
  }

  function applyTouchPolish(root) {
    qsa('.nawa-video-title', root).forEach((node) => {
      important(node, {
        display: 'none',
        width: '0',
        height: '0',
        'min-height': '0',
        'max-height': '0',
        margin: '0',
        padding: '0',
        opacity: '0',
        overflow: 'hidden',
        'pointer-events': 'none'
      });
    });

    qsa('.nawa-video-linked-product', root).forEach((node) => {
      important(node, {
        'box-sizing': 'border-box',
        height: '92px',
        'min-height': '92px',
        'max-height': '92px',
        padding: '6px',
        'border-radius': '14px',
        overflow: 'hidden'
      });
    });

    qsa('.nawa-video-linked-image', root).forEach((node) => {
      important(node, {
        width: '40px',
        height: '40px',
        'min-width': '40px',
        'min-height': '40px'
      });
    });

    qsa('.nawa-video-linked-title', root).forEach((node) => {
      important(node, {
        display: '-webkit-box',
        height: '31px',
        'min-height': '31px',
        'max-height': '31px',
        overflow: 'hidden',
        'white-space': 'normal',
        'text-overflow': 'ellipsis',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '2',
        'font-size': '11px',
        'line-height': '1.24',
        'font-weight': '520'
      });
    });

    qsa('.nawa-video-price-row strong', root).forEach((node) => {
      important(node, {
        position: 'absolute',
        top: '60px',
        right: '70px',
        left: '8px',
        'font-size': '13px',
        'font-weight': '760',
        'line-height': '1',
        'white-space': 'nowrap',
        overflow: 'visible',
        'text-overflow': 'clip'
      });
    });

    qsa('.nawa-video-price-row form, .nawa-video-price-row > button, .nawa-video-view-product', root).forEach((node) => {
      important(node, {
        position: 'absolute',
        right: '8px',
        bottom: 'auto',
        left: 'auto',
        top: '52px',
        width: '58px',
        'min-width': '58px',
        'max-width': '58px'
      });
    });

    qsa('.nawa-video-price-row button, .nawa-video-view-product', root).forEach((node) => {
      important(node, {
        width: '58px',
        'min-width': '58px',
        'max-width': '58px',
        height: '34px',
        'min-height': '34px',
        'max-height': '34px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        padding: '0 6px',
        'border-radius': '13px',
        'font-size': '10.2px'
      });
    });

    qsa('.nawa-video-price-row form button', root).forEach((node) => {
      important(node, {
        width: '100%'
      });
    });
  }

  function bindVideoFeed(root) {
    applyTouchPolish(root);

    qsa('[data-nawa-video-open]', root).forEach((button) => {
      if (button.dataset.nawaVideoBound) return;
      button.dataset.nawaVideoBound = 'true';
      button.addEventListener('click', () => openOverlay(button.dataset.nawaVideoOpen));
    });

    qsa('[data-nawa-video-close]', root).forEach((button) => {
      if (button.dataset.nawaVideoBound) return;
      button.dataset.nawaVideoBound = 'true';
      button.addEventListener('click', () => closeOverlay(button.closest('[data-nawa-video-overlay]')));
    });

    qsa('[data-nawa-video-filter]', root).forEach((button) => {
      if (button.dataset.nawaVideoBound) return;
      button.dataset.nawaVideoBound = 'true';
      button.addEventListener('click', () => {
        const selected = normalize(button.dataset.nawaVideoFilter);
        let visibleCount = 0;
        const emptyState = qs('[data-nawa-video-empty]', root);
        qsa('[data-nawa-video-filter]', root).forEach((node) => node.classList.toggle('is-active', node === button));
        qsa('[data-nawa-video-card]', root).forEach((card) => {
          const category = normalize(card.dataset.nawaVideoCategory);
          const showAll = !selected || selected === 'for you';
          const isVisible = showAll || category === selected;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        if (emptyState) emptyState.hidden = visibleCount > 0;
      });
    });
  }

  function init() {
    qsa('[data-nawa-video-feed]').forEach(bindVideoFeed);
    window.setTimeout(() => qsa('[data-nawa-video-feed]').forEach(applyTouchPolish), 250);
    window.setTimeout(() => qsa('[data-nawa-video-feed]').forEach(applyTouchPolish), 900);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllOverlays();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
